import axios from 'axios';

const Axios = axios.create();

export default Axios;
